import { createAction } from "redux-act";
export const setAvailableExtensions = createAction("SET_AVAILABLE_EXTENSIONS", (extensions) => extensions);
export const setInstalledExtensions = createAction("SET_INSTALLED_EXTENSIONS", (extensions) => extensions);
export const setExtensionsUpdate = createAction("SET_EXTENSIONS_UPDATE_TIME", (time) => time);
export const setOptionalExtensions = createAction("SET_OPTIONAL_EXTENSIONS", (optional) => optional);
